import { createStyles, Theme } from '@material-ui/core/styles';

const style = (theme: Theme) => createStyles({

    nodeName: {
        flexGrow: 1,
        padding: `0 ${theme.spacing.unit / 2}px`,
        cursor: 'default',
    },

});

export default style;
